import { HttpInterceptorFn } from '@angular/common/http';
import {environment} from "../../../../environments/environment";

/** localStorage key the AuthenticationService writes the JWT under (JSON-stringified). */
const TOKEN_NAME = 'appToken';

function readToken(): string | null {
  return readStored(TOKEN_NAME);
}

function readStored(key: string): string | null {
  const raw = localStorage.getItem(key);
  if (!raw) {
    return null;
  }
  // LocalStorageService stores values via JSON.stringify, so the token is quoted.
  try {
    const parsed = JSON.parse(raw);
    return parsed == null || parsed === '' ? null : String(parsed);
  } catch {
    return raw;
  }
}

export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  const apiKey = environment.apiKey;
  let headers = req.headers.append('X-API-KEY', apiKey);

  // Attach the internal user's JWT so the backend can attribute actions
  // (e.g. createdBy) to the real logged-in user. Skipped if already present.
  const token = readToken();
  if (token && !headers.has('Authorization')) {
    headers = headers.append('Authorization', `Bearer ${token}`);
  }

  // Most callers never passed X-User-Id/X-User-Name, so return history, notes and
  // fee/allowance edits were all stamped "System" (QA 2026-10-04). Fill them in here;
  // an explicit per-call header still wins.
  const userId = readStored('appUserId');
  const userName = readStored('appUserName');
  if (userId && !headers.has('X-User-Id')) {
    headers = headers.set('X-User-Id', userId);
  }
  if (userName && !headers.has('X-User-Name')) {
    headers = headers.set('X-User-Name', userName);
  }

  return next(req.clone({ headers }));
};
